import { render, staticRenderFns } from "./pageList.vue?vue&type=template&id=61158063&"
import script from "./pageList.vue?vue&type=script&lang=js&"
export * from "./pageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports